import { useEffect } from "react";

import { AMPLITUDE_EVENT_KEY } from "@simplyk/common";
import { useSearchParams } from "next/navigation";

import { AmplitudeEvents } from "../../constants/amplitude";

import { useAmplitude } from "./useAmplitude";

const VALID_AMPLITUDE_EVENT_VALUES = new Set<string>(Object.values(AmplitudeEvents));

export const useLogParamsEvent = () => {
  const searchParams = useSearchParams();
  const query = Object.fromEntries(searchParams.entries());
  const { logAmplitudeEvent } = useAmplitude();
  const amplitudeEvent = query[AMPLITUDE_EVENT_KEY] as AmplitudeEvents | AmplitudeEvents[] | undefined;

  useEffect(() => {
    const events = Array.isArray(amplitudeEvent) ? amplitudeEvent : amplitudeEvent ? [amplitudeEvent] : [];
    events.filter((event) => VALID_AMPLITUDE_EVENT_VALUES.has(event)).forEach((event) => logAmplitudeEvent(event));
  }, [amplitudeEvent, logAmplitudeEvent]);
};
